import type { ISuppliersFilters } from "~/Core/Models";

import axios from "./config";

const SCHEMA = "/kh";

export function GetAllPages(filters: ISuppliersFilters) {
  return axios.get(`${SCHEMA}/pages`, { params: filters });
}

export function GetPageById(id: string) {
  return axios.get(`${SCHEMA}/pages/${id}`);
}

export function GetPagesCategories() {
  return axios.get(`${SCHEMA}/categories`);
}
